'use client';

import { BellIcon } from './icons';

export function NotificationsBell({ hasUnread = false }: { hasUnread?: boolean }) {
  return (
    <button type="button" className="icon-btn" aria-label="Notifications">
      {BellIcon}
      {hasUnread ? <span className="bell-dot" /> : null}
    </button>
  );
}
